var map = {
	"./1/fa2.png": "b0f9",
	"./1/fdp.png": "61b3",
	"./1/kamada_kawai.png": "7d96",
	"./1/neato.png": "7258",
	"./1/pmds.png": "eb7d",
	"./1/sfdp.png": "eca0",
	"./1/spectral.png": "9197",
	"./1/spring.png": "d845",
	"./back-manual.png": "517d",
	"./hard-manual.png": "b2e1",
	"./heart-manual.png": "f525",
	"./next-manual.png": "5b66",
	"./quit-manual.png": "670e",
	"./statistic-manual.png": "7848"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";